import { useEffect, useState } from 'react';
import Header from './Header';
import Nav from './Nav';
import Main from './Main';
import { useAuth } from '../../hooks/useAuth';
import { Alert, Snackbar } from '@mui/material';
import CreateCase from '../../components/CreateCase';
import { useNavigate } from 'react-router-dom';
import { post } from '../../api';
import { useSelector } from 'react-redux';

const selectMailData = (state) => state.mail.data;

function DashboardLayout({ showSmallSizeMenu, setShowSmallSizeMenu, children }) {
    const { user, isAuthenticated, getUserDetailsNotAsync, refreshSessionData } = useAuth();
    let userDetails = getUserDetailsNotAsync();
    
    const [currentDetail, setCurrentDetail] = useState({});
    const [openCaseModal, setOpenCaseModal] = useState(false);
    
    const [openToster, setOpenToster] = useState(false);
    const [tosterVariant, setTosterVariant] = useState('info');
    const [tosterMessage, setTosterMessage] = useState('');
    const [autoHideDuration, setAutoHideDuration] = useState(6000);
    const [hasPersonalProducts, setHasPersonalProducts] = useState(true);
    
    const data = useSelector(selectMailData);
    const [displayPrimeMailsCount, setDisplayPrimeMailsCount] = useState(0);
    const [displayPrimeAssessment, setDisplayPrimeAssessment] = useState(false);
    const [paymentDetails, setPaymentDetails] = useState([]);
    
    const navigate = useNavigate();

    useEffect(() => {
        document.addEventListener('openToster', handleOpenToster);
        document.addEventListener('createCase', handleCreateCase);
        document.addEventListener('navigate', handleNavigate);
        document.addEventListener('navigateWithReload', handleNavigateWithReload);

        return () => {
            document.removeEventListener('openToster', handleOpenToster);
            document.removeEventListener('createCase', handleCreateCase);
            document.removeEventListener('navigate', handleNavigate);
            document.removeEventListener('navigateWithReload', handleNavigateWithReload);
        };
    }, []);

    // useEffect(() => {
    //     post('custom/checkUserHasPersonalProduct', { accountIds: userDetails.contact.relatedAccounts?.map((item) => item.accountId) }).then((result) => {
    //         if (result.isSuccess && result.data === 'true') {
    //             setHasPersonalProducts(true);
    //         } else {
    //             setHasPersonalProducts(false);
    //         }
    //     });
    // }, []);

    useEffect(() => {
        getRecurringPaymentDetails();
        handleGetSurvey();
        handleGetMails()
    }, []);

    useEffect(() => {
        const totalCount = getReadCount(data?.records && Array.isArray(data?.records) ? data.records : []);
        setDisplayPrimeMailsCount(totalCount);
    }, [data?.records]);

    const getReadCount = (mailMessageAllDataList = []) => {
        let records = mailMessageAllDataList?.filter((cItem) => {
            return !cItem.read;
        });
        return records.length;
    };

    const handleGetMails = () => {
        if (userDetails?.contact?.relatedAccounts) {   
            try {
                post(`custom/getMails`, { accountIds: userDetails.contact.relatedAccounts.map((item) => item.accountId) }).then((result) => {
                    if (result.isSuccess) {
                        const records = result.data?.map((item) => {
                            return { ...item, relatedTo: 'PRIME mail' };
                        });
                        const totalCount = getReadCount(records && Array.isArray(records) ? records : []);
                        setDisplayPrimeMailsCount(totalCount);
                    } else {
                        setDisplayPrimeMailsCount(0);
                    }
                });
            } catch (error) {
                console.error('handleGetMails error: ', error);
                setDisplayPrimeMailsCount(0);
            }
        }
    };

    const handleGetSurvey = () => {
        if (userDetails?.contact?.id) {
            try {
                post(`custom/getAssignedSurveys`, { contactId: userDetails?.contact?.id }).then((result) => {
                    if (result.isSuccess) {
                        const data = result.data;
                        setDisplayPrimeAssessment(data?.length > 0 ? true : false);
                    } else {
                        setDisplayPrimeAssessment(false);
                    }
                });
            } catch (error) {
                console.error('handleGetSurvey error: ', error);
                setDisplayPrimeAssessment(false);
            }
        }
    };

    const getRecurringPaymentDetails = async () => {
        try {
            const result = await post('custom/getRecurringPaymentDetails', { accountIds: userDetails?.contact?.relatedAccounts?.map((item) => item.accountId) });
            if (result.isSuccess) {
                const data = result?.data || [];
                setPaymentDetails(Array.isArray(data) ? data : []);
            } else {
                setPaymentDetails([]);
            }
        } catch (error) {
            console.log('getRecurringPaymentDetails error: ', error, error?.errorMessage);
            setPaymentDetails([]);
        }
    };


    const handleNavigate = async (event) => {
        navigate(event.detail.url);
    };

    const handleNavigateWithReload = async (event) => {
        window.location.href = event.detail.url;
    };

    const handleCreateCase = async (event) => {
        setCurrentDetail(event.detail);
        setOpenCaseModal(true);
    };

    const handleOpenToster = async (event) => {
        const detail = event.detail;
        setTosterVariant(detail.variant);
        setTosterMessage(detail.message);
        if (detail.autoHideDuration) {
            setAutoHideDuration(detail.autoHideDuration);
        }
        setOpenToster(true);
    };

    const handleTosterClose = () => {
        setOpenToster(false);
    };

    const handleCreateCaseClose = () => {
        setOpenCaseModal(false);
    };

    return (
        <>
            <Header displayDetails={{
                displayPrimeAssessment,
                displayPrimeMailsCount,
                paymentDetails
            }}/>
            <Nav showSmallSizeMenu={showSmallSizeMenu} setShowSmallSizeMenu={setShowSmallSizeMenu} displayDetails={{
                displayPrimeAssessment,
                displayPrimeMailsCount,
                paymentDetails
            }}/>
            <Main showSmallSizeMenu={showSmallSizeMenu}>{children}</Main>
            <Snackbar
                sx={{ left: { lg: 'calc(50% + 140px)' } }}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={openToster}
                autoHideDuration={autoHideDuration}
                onClose={handleTosterClose}
            >
                <Alert
                    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', '& .MuiAlert-action': { paddingTop: '0px' } }}
                    onClose={handleTosterClose}
                    severity={tosterVariant}
                    variant="filled"
                >
                    {tosterMessage}
                </Alert>
            </Snackbar>
            <CreateCase hasPersonalProducts={hasPersonalProducts} isOpen={openCaseModal} detail={currentDetail} onClose={handleCreateCaseClose} />
        </>
    );
}

export default DashboardLayout;
